import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { spacesApi } from '@/lib/api';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useSpaceSettlementReceipt(spaceId: string, receiptId: string | null) {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  return useSWR(userId && receiptId ? ['space-receipt', userId, spaceId, receiptId] : null,
    () => fetch((token) => spacesApi.settlementReceipt(token, spaceId, receiptId!)),
    { ...LONG_LIVED_SWR_OPTIONS, keepPreviousData: false, shouldRetryOnError: false });
}
